module.exports = __webpack_public_path__ + "img/CC7C5F_A15436_B26346_AF5C3C-256px.38ec8560.png";